import { CITIES, countryFlag, countryName } from 'shared';

interface Props {
  /** Код страны ISO-2 из заявки. Главный источник. */
  code?: string | null;
  /**
   * Город — запасной путь для заявок, созданных до свободной географии:
   * у них кода страны в базе нет, но город обычно из справочника.
   */
  address?: string;
}

/**
 * Флаг страны рядом с городом.
 *
 * На направлении Москва → Минск международная перевозка должна быть
 * видна с одного взгляда, без чтения адреса. Флаг считается из кода
 * страны арифметикой по Unicode, а не берётся из справочника: справочник
 * знает десять стран СНГ, и заявка из Техаса оставалась без флага, хотя
 * код страны у неё в базе есть.
 */
export default function CountryFlag({ code, address }: Props) {
  const cc = code ?? (address ? CITIES[address]?.country : null) ?? null;
  const flag = countryFlag(cc);
  if (!flag) return null;

  return (
    <span className="flag" title={countryName(cc)}>
      {flag}
    </span>
  );
}
